/* globals module, require */

var Pikaday = require('pikaday'),
	moment = require('moment'),
	$otherAmount,
	selectedAmount,
	$cart;

module.exports = {
	init: function() {
		'use strict';

		$cart = $('.minicart');
		$otherAmount = $('#other-amount');

		var _self = this,
			deliveryDate = document.querySelector('[data-delivery-date]'),
			deliveryDateInput = document.querySelector('[data-delivery-date-input]'),

			picker = new Pikaday({
				field: deliveryDate,
				container: deliveryDate.nextElementSibling,
				minDate: new Date(),
				i18n: window.snowdome.pikadayi18n,
				format: 'dddd Do MMMM',
				onSelect: function(date) {
					deliveryDateInput.value = moment(date).format('YYYY-MM-DD');
					$(picker.el).addClass('completed');
					_self.checkSidebar();
				},
				onOpen: function() {
					$(picker.el).closest('.form__group').toggleClass('datepicker--open');
				},
				onClose: function() {
					$(picker.el).closest('.form__group').toggleClass('datepicker--open');
				},
			});

		$('[data-amount]').on('change', function() {
			if(this.checked) {
				selectedAmount = this;
			}

			_self.checkSidebar();
		});

		$('#voucher-info [name]').on('keyup', function() {

			_self.checkSidebar();
		});
	},

	checkSidebar: function() {
		'use strict';

		var _self = this
		  , info = ''
		  ,	extra = 0;

		$cart.find('.product--extra').remove();

		if(selectedAmount) {
			$cart.find('.product__name').text('Gift Voucher');			

			if($('[name="amount"]:checked').val() === 'other') {
				_self.enableOtherAmount();
			} else {
				_self.disableOtherAmount();
			}

			$('#voucher-info [name]').each(function(index, el) {
				var $el = $(el);

				info += '<dt class="product__type">' + $el.prev('label').text() + '</dt>';
				info += '<dd>';
					info += (el.hasAttribute('data-delivery-date-input')) ? $el.next().val() : $el.val();
				info += '</dd>';
			});

			$cart.find('dl').html(info);

			if(typeof $cart.attr('data-offer') !== 'undefined' &&  $cart.attr('data-offer') === 'yes'){
				var amount = parseFloat(selectedAmount.value);
				if(!isNaN(amount) && amount >= 50) {
					extra = this.checkDiscountBand(amount);
					$cart.find('.minicart__products').append('\
						<li class="product product--extra">\
							<h4 class="product__name">Gift Voucher Offer</h4>\
							<span class="product__price h4"> -£' + extra.toFixed(2) + '</span>\
							<p>Happy Holidays!</p>\
						</li>\
					');
				}
			}

			var price = parseFloat(selectedAmount.value);

			if(!isNaN(price)) {
				$cart.find('.product:not(.product--extra) .product__price').text('£' + Math.max(5, Math.min(1000, price + extra)).toFixed(2));
				$cart.find('h1').text('£' + Math.max(5, Math.min(1000, price)).toFixed(2));
			} else {
				$cart.find('h1, .product:not(.product--extra) .product__price').empty();
			}

			$cart.show();
		} else {
			$cart.hide();
		}
	},

	checkDiscountBand: function(amount) {
		var discount = 0;
		if(!isNaN(amount) && amount >= 50) {
			if(amount >= 50 && amount < 100){
				discount = 5.00;
			} else if(amount >= 100 && amount < 150){
				discount = 10.00;
			} else if(amount >= 150 && amount < 200){
				discount = 15.00;
			} else if(amount >= 200 && amount < 250){
				discount = 20.00;
			} else if(amount >= 250 && amount < 300){
				discount = 25.00;
			} else if(amount >= 300 && amount < 350){
				discount = 30.00;
			} else if(amount >= 350 && amount < 400){
				discount = 35.00;
			} else if(amount >= 400 && amount < 450){
				discount = 40.00;
			} else if(amount >= 450 && amount < 500){
				discount = 45.00;
			} else if(amount >= 500 && amount < 550){
				discount = 50.00;
			} else if(amount >= 550 && amount < 600){
				discount = 55.00;
			} else if(amount >= 600 && amount < 650){
				discount = 60.00;
			} else if(amount >= 650 && amount < 700){
				discount = 65.00;
			} else if(amount >= 700 && amount < 750){
				discount = 70.00;
			} else if(amount >= 750 && amount < 800){
				discount = 75.00;
			} else if(amount >= 800){
				discount = 80.00;
			}
		}

		return discount;
	},

	enableOtherAmount: function() {
		'use strict';
		var _self = this;

		$otherAmount.css('display', ($(window).width() > 1025) ? 'inline-block' : 'block');

		$('[data-custom-amount]').off('keyup');
		$('[data-custom-amount]').on('keyup', function() {

			if(this.value.length) {
				selectedAmount = this;
			}

			_self.checkSidebar();
		});
	},

	disableOtherAmount: function() {
		'use strict';

		$cart.find('h1, .product__price').text('£' + parseFloat(selectedAmount.value).toFixed(2));
		$('[data-custom-amount]').off('keyup');
		$otherAmount.hide();
	},
};
